/* eslint-disable import/prefer-default-export */
export function clearStores(actionContext) {
    actionContext.dispatch('CLEAR_STORES');
}
